var checkboxes = {
    init: function () {
        this.setListeners();
    },

    setListeners: function () {
        var $this = this;

        $('.filters ul').find('a:not([data-toggle])').on('click', function(e) {
            window.location.href = this.href;
            console.log(this.href);
        });
    }
};

(function ($) {
    checkboxes.init();
})(jQuery);